module.exports = __webpack_public_path__ + "assets/img/yutari-photo02.9aa2b9ad.jpg";